import React, { useState, forwardRef } from 'react'
import { Box, Icon, Typography } from '@mui/material'
import { Field, Form, Formik, ErrorMessage } from 'formik'
import * as yup from 'yup'

// Local Imports
import AdxFormModal from 'components/reusable/modal/AdxFormModal'
import AdxInput from 'components/custom/AdxInput'
import AdxDatePicker from 'components/custom/AdxDatePicker'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'

// API services
import { usePostNewCustomHoliday } from 'services/api/modules/leave/holiday'
import { format } from 'date-fns'
import AdxButton from 'components/custom/AdxButton'

const CustomHolidayForm = forwardRef((props, ref) => {
  const [modalState, setModalState] = useState(false)
  const mutation = usePostNewCustomHoliday()

  const handleOpen = () => {
    setModalState(true)
  }

  const handleClose = () => {
    setModalState(false)
  }

  const validationSchema = yup.object().shape({
    name: yup.string().required('Name is required'),
    date: yup.mixed().required('Please select a date').nullable(),
  })
  return (
    <>
      <AdxButton
        variant={'ghost'}
        onClick={handleOpen}
        sx={{
          '&.MuiButtonBase-root': {
            justifyContent: 'flex-start',
          },
          width: '100%',
        }}
      >
        <Box
          display={'flex'}
          flexDirection={'row'}
          alignItems={'center'}
          justifyContent={'flex-start'}
        >
          <Icon sx={{ color: 'alternate.main', marginRight: 2 }}>add</Icon>
          <Typography
            sx={{ fontWeight: 'bold' }}
            variant="subtitle1"
            color={'alternate.main'}
            mr={2}
          >
            Add Custom Holiday
          </Typography>
        </Box>
      </AdxButton>

      <Formik
        initialValues={{
          name: '',
          date: '',
          type: 'Custom',
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          const data = {
            holiday: [
              {
                name: values.name,
                date: format(values.date, 'yyyy/MM/dd'),
                type: values.type,
              },
            ],
          }
          mutation.mutate(data, {
            onSuccess: () => handleClose(),
          })
        }}
      >
        {({ handleChange, handleBlur, setFieldValue, handleSubmit, errors, touched }) => {
          return (
            <Form onSubmit={handleSubmit}>
              <AdxFormModal
                title="New custom holiday"
                subtitle=""
                open={modalState}
                onClose={handleClose}
                handleClose={handleClose}
                sxModal={{
                  width: { xs: '100vw', lg: '500px' },
                }}
                enableFooter
                actionText="Create"
                handleAction={handleSubmit}
              >
                <Box>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Field
                      name={`name`}
                      as={AdxInput}
                      charLimit={50}
                      errorMessage={<ErrorMessage name={`name`} component={AdxErrorMessage} />}
                      isErrorShown={errors.name && touched.name}
                      sx={{ width: 1 }}
                      label="Custom Holiday Name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <Field
                      name={`date`}
                      as={AdxDatePicker}
                      errorMessage={<ErrorMessage name={`date`} component={AdxErrorMessage} />}
                      isErrorShown={errors.date && touched.date}
                      label="Select Holiday Date"
                      type="date"
                      onChange={(e) => {
                        setFieldValue(`date`, e)
                      }}
                      onBlur={handleBlur}
                    />
                  </Box>
                </Box>
              </AdxFormModal>
            </Form>
          )
        }}
      </Formik>
    </>
  )
})

export default CustomHolidayForm
